<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table v-if="load == true" :headers="headers" :items="document_access_log_list" sort-by="standard"
                class="elevation-1 mytable" dense :search="search" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Document Access Logs</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Document Access Logs</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>

                                            <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete dense v-model="editedItem.document_id"
                                                        :items="document_list" item-text="document_name"
                                                        item-value="document_id" label="Document Name" persistent-hint
                                                        hint="Document Name..." single-line></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete dense
                                                        v-model="editedItem.documentAccessControlMaster_id"
                                                        :items="document_access_control_master_list"
                                                        item-text="documentAccessControlMaster_name"
                                                        item-value="documentAccessControlMaster_id"
                                                        label="Document Access Control Master Name" persistent-hint
                                                        hint="Document Access Control Master Name..."
                                                        single-line></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete dense v-model="editedItem.assignedto_id"
                                                        :items="employee_list" item-text="name" item-value="id"
                                                        label="Instructor" persistent-hint hint="Instructor..."
                                                        single-line></v-autocomplete>
                                                </v-col>
                                            </v-row>



                                            <v-row>
                                                <v-col cols="6">
                                                    <p class="padding-bot"><b>Access Date</b></p>
                                                    <input type="date" class="padding-bot"
                                                        v-model="editedItem.access_date" />
                                                </v-col>

                                            </v-row>
                                            <!-- <v-row>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active?"></v-checkbox>
                                                </v-col>
                                            </v-row> -->

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <!-- 
                <template v-slot:[`item.isactive`]="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template> -->





                <template v-slot:[`item.action`]="{ item }">
                    <v-avatar style size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit" style>edit</v-icon>
                    </v-avatar>

                </template>

            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        errorMsg: {
            access_date: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        items: [],
        dialog: false,
        search: "",
        // extraBreadcrumbItems: [
        //     { text: "Document Access Logs Master", disabled: true, href: "" },

        // ],
        
        // breadcrumbClass: "breadcrumb-style2",
        load: false,
        headers: [
            {
                text: "Document",
                value: "document_name",
            },
            {
                text: "Document Access Control Master",
                value: "documentAccessControlMaster_name",
            },

            {
                text: "Instructor",
                value: "assignedto_name",
            },

            {
                text: "Access Date",
                value: "access_date_show",
            },

            // {
            //     text: "Active",
            //     value: "isactive",
            // },
            { text: "Actions", value: "action", sortable: false },
        ],
        document_access_log_list: [],
        employee_list: [],
        document_access_control_master_list: [],
        document_list: [],

        editedIndex: -1,
        editedItem: {
            id: "",
            document_id: "",
            documentAccessControlMaster_id: "",
            assignedto_id: "",

            access_date: "",

            //  isactive: false,

        },
        defaultItem: {
            id: "",
            document_id: "",
            documentAccessControlMaster_id: "",
            assignedto_id: "",

            access_date: "",

            // isactive: false,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Document Access Logs " : "Edit Document Access Logs";
        },

    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },


    mounted() {
        this.onload();
    },
    methods: {
        onload() {
            axios
                .post("/AdmissionMaster/getDocumentAccessLogs")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.document_list = res.data.document_list;
                        this.document_access_control_master_list = res.data.document_access_control_master_list;
                        this.employee_list = res.data.employee_list;
                        this.document_access_log_list = res.data.document_access_log_list;
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        initializeErrorMsgFalse() {
            this.errorMsg.access_date = false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        editItem(item) {

            this.editedIndex = this.document_access_log_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },



        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/editDocumentAccessLogs", this.editedItem)
                        .then((res) => {
                            if (res.data.code == "SUCCESS") {
                                this.onload();

                                this.showSnackbar("#4caf50", "Document Access Logs Updated Successfully..."); // show snackbar on success
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/saveDocumentAccessLogs", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                // this.standred_master_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Document Access Logs Added Successfully..."); // show snackbar on success
                                this.onload();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Document Logs Control Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }
        }, // end of save()

        isValidated() {
            if (this.editedItem.access_date) {
                return true;
            } else {
                if (!this.editedItem.access_date) {
                    this.errorMsg.access_date = true;
                }

                return false;
            }
        }, // .....end of isValidated()
        // toggle(item) {
        //     const data = {
        //         section_id: item.id,
        //         toggle: item.isactive,
        //     };
        //     this.overlay = true;
        //     axios
        //         .post("/AdmissionMaster/toggleDocumentAccessLogs", data)
        //         .then((res) => {
        //             this.overlay = false;
        //             if (res.data.code == "SUCCESS") {
        //                 this.showSnackbar("#4caf50", "Document Access Logs Status Changed!"); // show snackbar
        //             } else if (res.data.code == "NA") {
        //                 this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
        //             }
        //         })
        //         .catch((error) => {
        //             this.overlay = false;
        //         })
        //         .finally(() => {
        //             this.overlay = false;
        //         });
        // },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
